/* eslint-disable @next/next/no-sync-scripts */
/* eslint-disable react/no-danger */
/* eslint-disable @next/next/no-page-custom-font */
import { baseMinCss } from "../../utils/stylesUtil/baseMin";
import { flightInlinceCss } from "../../utils/stylesUtil/flightsInline";
import { jqueryUIMinCss } from "../../utils/stylesUtil/jqueryUIMin";
import { seoFlightsCss } from "../../utils/stylesUtil/seoFlights";
import { getFontUrl } from "../../utils/helper/utils";

export const appendHeadDistanceDT = (props) => {
  const {
    ccde,
    flightListData,
    fareCalendar,
    appConfig,
    tokens,
    lang,
    language,
    isGoibibo,
    pageLoad = {},
    currentDomainName,
    devId,
    mcid,
  } = props || {};
  let cssPath;
  // let mapPath;
  if (appConfig && appConfig.liveMode) {
    cssPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css`;
  } else {
    cssPath = "http://localhost:3000/_next/static/css";
  }

  return (
    <>
      <link href="http://imgak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://jsak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://cssak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://bid.g.doubleclick.net" rel="preconnect" crossOrigin />
      {!isGoibibo && <link href="http://makemytrip.tt.omtrdc.net" rel="preconnect" crossOrigin />}
      <link
        rel="preload"
        href={getFontUrl(language, isGoibibo)}
        as="style"
        onload="this.onload=null;this.rel='stylesheet'"
      />
      <style>
        {`.placeholder-content {
            height: 64px;
            overflow: hidden;
            position: relative;
            animation-duration: 1.7s;
            animation-fill-mode: forwards;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
            animation-name: placeholderAnimate;
            background: #f6f7f8;
            background: linear-gradient(to right, #eee 2%, #ddd 18%, #eee 33%);
          }`}
      </style>
      {isGoibibo ? (
        <link href={`${cssPath}/dweb-header.min.css`} rel="stylesheet" />
      ) : (
        <link href={`${cssPath}/header.min.css`} rel="stylesheet" />
      )}
      <style dangerouslySetInnerHTML={{ __html: flightInlinceCss }} />
      <style dangerouslySetInnerHTML={{ __html: jqueryUIMinCss }} />
      <style dangerouslySetInnerHTML={{ __html: baseMinCss }} />
      <style dangerouslySetInnerHTML={{ __html: seoFlightsCss }} />
      <script defer src="https://code.jquery.com/ui/1.12.1/jquery-ui.min.js" />
      <script type="text/javascript" src="https://code.jquery.com/jquery-3.1.1.min.js" />
      <link href={`${cssPath}/bootstrap.min.css`} rel="stylesheet" />
      <script
        dangerouslySetInnerHTML={{
          __html: `
       var src_city_code = '${tokens.src_city_code}';
       var dest_city_code = '${tokens.dest_city_code}';
       var src_city_name = '${tokens.src_city_name}';
       var dest_city_name = '${tokens.dest_city_name}'
       var cheap_date = '${tokens.cheap_MMddyyyy}';
       var showFareCalendar = ${!!fareCalendar};
       `,
        }}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
      var ccdeVal = "&ccde=IN";
      window.pageLoad = ${JSON.stringify(pageLoad)};
      window.currentDomain = "${currentDomainName || ''}";
      window.showLeaveIntent = true;
      window.lang = "${lang}";
      window.language = "${language}";
      ccdeVal = "${ccde && ccde !== "" ? `&ccde=${ccde}` : "&ccde=IN"}";
      window.devId = "${devId || ''}";
      window.mcid = "${mcid || ''}";
      var Listing = ${
        flightListData && flightListData.length !== 0 ? JSON.stringify(flightListData) : "[]"
      };

      `,
        }}
      />
      <style>
        {`#map {
          width: 100%;
          height: 400px;
          z-index: 0;
          margin-top: 25px;
          }`}
      </style>
      <link
        rel="stylesheet"
        href="https://unpkg.com/leaflet@1.3.3/dist/leaflet.css"
        integrity="sha512-Rksm5RenBEKSKFjgI3a41vrjkw4EVPlJ3+OiI65vTjIdo9brlAacEuKOiQ5OFh7cOI1bkDwLqdLw3Zg0cRJAAQ=="
        crossOrigin=""
      />
      {/* <!-- Make sure you put this AFTER Leaflet's CSS --> */}
      <script
        src="https://unpkg.com/leaflet@1.3.3/dist/leaflet.js"
        integrity="sha512-tAGcCfR4Sc5ZP5ZoVz0quoZDYX5aCtEm/eu1KhSLj2c9eFrylXZknQYmxUssFaVJKvvc0dJQixhGjG2yXWiV9Q=="
        crossOrigin=""
      />
    </>
  );
};
